import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createLunchMenu,
  deleteLunchMenu,
  finishLunchMenu,
  getLunchMenu,
  getLunchMenus,
  updateLunchMenu,
  type LunchMenuIn,
} from "../api/lunchMenus";

const LUNCH_MENUS_KEY = ["lunch-menus"] as const;

export const useLunchMenus = () =>
  useQuery({ queryKey: LUNCH_MENUS_KEY, queryFn: getLunchMenus });

export const useLunchMenu = (menuId: number | null) =>
  useQuery({
    queryKey: [...LUNCH_MENUS_KEY, menuId],
    queryFn: () => getLunchMenu(menuId as number),
    enabled: menuId != null,
  });

/** След всяка промяна: списъкът + каталогът на „Маркиране" (групата „Обедно меню"). */
const useInvalidateLunch = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: LUNCH_MENUS_KEY });
    queryClient.invalidateQueries({ queryKey: ["menu"] });
  };
};

export const useSaveLunchMenu = () => {
  const invalidate = useInvalidateLunch();
  return useMutation({
    mutationFn: ({ menuId, data }: { menuId: number | null; data: LunchMenuIn }) =>
      menuId == null ? createLunchMenu(data) : updateLunchMenu(menuId, data),
    onSuccess: invalidate,
  });
};

export const useFinishLunchMenu = () => {
  const invalidate = useInvalidateLunch();
  return useMutation({ mutationFn: finishLunchMenu, onSuccess: invalidate });
};

export const useDeleteLunchMenu = () => {
  const invalidate = useInvalidateLunch();
  return useMutation({ mutationFn: deleteLunchMenu, onSuccess: invalidate });
};
